import Vue from 'vue';
import VueI18n from 'vue-i18n';
import enLocale from 'element-ui/lib/locale/lang/en';
import deLocale from 'element-ui/lib/locale/lang/de';

Vue.use(VueI18n);

const hostParts = window.location.host.split('.');
const domain = hostParts.length > 1 ? hostParts[hostParts.length - 1] : 'en';
if (domain === 'uk') {
  Vue.prototype.$localeString = 'en-GB';
} else {
  Vue.prototype.$localeString = 'de-DE';
}

function loadLocaleMessages () {
  const locales = require.context('./locales', true, /[A-Za-z0-9-_,\s]+\.json$/i);
  const messages = {};
  locales.keys().forEach(key => {
    const matched = key.match(/([A-Za-z0-9-_]+)\./i);
    if (matched && matched.length > 1) {
      const locale = matched[1];
      messages[locale] = locales(key);
    }
  });

  //Load messages for element UI
  Object.assign(messages.en, enLocale);
  Object.assign(messages.de, deLocale);

  return messages;
}

export default new VueI18n({
  locale: 'en',
  messages: loadLocaleMessages()
});
